/**
 * Imports
 */
import { Button } from 'components';
import { VibrantIcon } from 'components/VibrantIcon';
import { userEmail } from 'features/user/redux/actions';
import { firebaseGoogleLogin } from 'firebaseAPI';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'router/RootRouter';
import { styled } from 'theme';

/**
 * Styling
 */
const StyledButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.Background.GoogleLogin};

  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    margin-right: 12px;
  }
`;

/**
 * Types
 */
export interface GoogleLoginProps {}

/**
 * GoogleLogin component
 */
const GoogleLogin: React.FC<GoogleLoginProps> = (_props) => {
  const navigation = useHistory();
  const dispatch = useDispatch();
  /* Local state */
  const [isLoading, setIsLoading] = React.useState(false);

  const _handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      const resp = await firebaseGoogleLogin();
      dispatch(userEmail({ email: resp.email }));
      setIsLoading(false);
      navigation.push(ROUTES.home.path);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <StyledButton
      type="primary"
      onClick={_handleGoogleLogin}
      block
      loading={isLoading}
    >
      <VibrantIcon icon="google" color="White000" />
      Login with Google
    </StyledButton>
  );
};

/**
 * Exports
 */
export { GoogleLogin };
